module.exports = __webpack_public_path__ + "static/media/Left fist top.5257fe9a.svg";